<template>
    <div style="position: relative !important;">
        <div class="az-form-content">
            <p v-if="comprador.resultadoItensELotes.length === 0"
               class="mensagem-quando-vazio">
                Não foi possível carregar os itens e/ou grupo de itens desta compra direta.
            </p>
            <p v-else-if="ehProcessoDeHomologacaoAutoridadeSuperior && resultados.length === 0"
               class="mensagem-quando-vazio">
                Não há itens/lote desta compra aguardando homologação.
            </p>

            <painel-ranking v-model="resultados"
                            v-else
                            :casasDecimais="quantidadeCasasDecimais"
                            :situacaoCompraDireta="situacaoCompraDireta"
                            :semValorReferencia="semValorReferencia"
                            :compraDiretaId="Number.parseInt(compraDiretaId)"
                            :numeroProtocolo="numeroProtocolo"
                            :existeItemLoteComSituacaoEmAndamento="existeItemLoteComSituacaoEmAndamento"
                            :totalElements="totalElements"
                            :totalPages="totalPages"
                            :paginacao="paginacao"
                            @eventoVisualizarProposta="eventoVisualizarProposta"
                            @desempatar="iniciarDesempateFechado"
                            @declararVencedor="((dados) => processarAcaoAdjudicarDeclararVencedor(dados, 'DECLARAR_VENCEDOR'))"
                            @enviarParaHomologacao="((dados) => processarAcaoAdjudicarDeclararVencedor(dados, 'ENVIAR_PARA_HOMOLOGACAO'))"
                            @desclassificar="desclassificar"
                            @inabilitar="inabilitar"
                            @habilitar="habilitar"
                            @reclassificar="reclassificar"
                            @negociar="negociar"
                            @analisarDocumentacao="analisarDocumentacao"
                            @baixarAta="baixarAtaCompraDireta"
                            @baixarHistoricoLances="baixarHistoricoLances"
                            @baixarResultado="baixarResultado"
                            @cancelarAdjudicacao="cancelarAdjudicacao"
                            @cancelarDeclaracaoVencedor="cancelarDeclaracaoVencedor"
                            @encerrarCompra="encerrarCompra"
                            @reverterSituacao="reverterSituacao"
                            @baixarTodosDocumentos="executarEventoBaixarTodosDocumentos"
                            @enviarSolicitacaoReadequacaoItemLote="enviarSolicitacaoReadequacaoItemLote"
                            @cancelarNegociacao="cancelarNegociacao"
                            @abrirChatMensages="processarEventoAbrirchatMensagens"
                            @abrirChatNoTabItensLotes="processarEventoAbrirChatNoTabItensLotes"
                            @cancelarEnvioHomologacao="processarEventoCancelarEnvioHomologacao"
                            @propagarEventoAbrirModalMotivoDevolucao="processarEventoAbrirModalMotivoJustificativa"
                            @homologarAdjudicarItemLote="deveMostrarModalHomologacao = true"
                            @baixarTermoHomologacao="processarEventoBaixarTermoHomologacao"
                            @eventoIniciarDesempateManual="iniciarDesempateManualAutomatico"
                            @tempoDesempateEncerrado="tempoDesempateEncerrado"
                            @processarPrimerioEnvioEsfinge="processarPrimerioEnvioEsfinge"
                            @processarAbrirModalAcompanhamentoEnvioEsfinge="abrirModalAcompanhamentoEnvioEsfinge"
                            @removerProposta="((dados) => processarEventoRemoverProposta(dados))"/>

          <div class="az-pagination" v-if="totalPages > 1">
            <v-pagination
                v-model="paginacaoInterna.page"
                :length="totalPages"
            />

            <div class="az-select-pagination">
              <span>Linhas por página:</span>
              <v-select
                  :items="linhasPorPagina"
                  v-model="paginacaoInterna.rowsPerPage"
                  hide-details
                  dense
              />
            </div>
          </div>


        </div>

        <div class="az-actions-form ajuste-acoes">
            <botao-voltar @voltar="tratarEventoVoltar"/>
        </div>
        <chat-sheet :resultados="resultados"
                    :ehPerfilComprador="true"
                    @enviarMensagem="processarEventoEnviarMensagem"
                    @tabClicked="processarEventoTabCliked"
                    @fornecedorClicked="processarEventoFornecedorClicked"
                    @fecharChat="processarEventoFecharChat">
        </chat-sheet>
        <modal-enviar-motivo-justificativa key="global-motivo-justificativa-provider"
                                           com-botao-cancelar
                                           com-botao-confirmar
                                           texto-botao-confirmar="Devolver"
                                           :deveMostrarModalMotivoJustificativa="deveMostrarModalMotivoJustificativa"
                                           :titulo="`${elementoEmDevolucao.descricao} | Motivo de devolução`"
                                           @confirmar="processarConfirmacaoDevolucaoItemLote"
                                           @cancelar="fecharModalMotivoDevolucao"/>

        <modal-homologar-adjudicar-item-lote :deveMostrarModalHomologacao="deveMostrarModalHomologacao"
                                             :resultados="itensLotesAguardandoHomologacao"
                                             @confirmar="adjudicar"
                                             @cancelar="fecharModalHomologacao"/>

        <modal-desempate-manual-automatico v-model="itemLoteEmDesempate"
                                           :deveMostrarModalDesempateManual="deveMostrarModalDesempateManual"
                                           :posicao-empate="itemLoteEmDesempate.empatePosicao"
                                           @cancelar="fecharModalDesempateManual"
                                           @confirmar="processarConfirmacaoDesempateManual"
                                           @desempatarPorSorteio="desempatar"/>

        <modal-acompanhamento-envio-esfinge :mostrarModalAcompanhamentoEnvioEsfinge="mostrarModalAcompanhamentoEnvioEsfinge"
                                            :envio-esfinge="envioEsfinge"
                                            @processarEnvioModalAcompanhamentoEsfinge="processarEnvioModalAcompanhamentoEsfinge"
                                            @processarAlterarDispensaEsfinge="alterarDispensaEsfinge"
                                            @processarBuscarDispensaEsfinge="buscarDispensaEsfinge"
                                            @processarCancelarDispensaEsfinge="cancelarDispensaEsfinge"
                                            @processarFecharModalAcompanhamentoEnvioEsfinge="fecharModalAcompanhamentoEnvioEsfinge"/>

        <alerta-aviso-validacao-saldo
            :mensagens-alerta="mensagensAlertaControleSaldo"
            :deveAbrir="deveAbrirAlertaControleSaldo"
            @confirmar="confirmarDeclaracaoVencedor"
            @cancelar="fecharModalAlertaSaldo"
        />
    </div>
</template>

<script>
import SmartTimerMixin from '@/core/mixins/SmartTimerMixin'
import {mapState} from 'vuex'
import {actionTypes, mutationTypes} from '@/core/constants'
import PainelRanking from './painel-ranking/PainelRanking'
import ChatSheet from '@/views/pages/commons/chat-compra-direta/chat-area/ChatSheet'
import ModalEnviarMotivoJustificativa from '@/views/components/ModalEnviarMotivoJustificativa'
import ModalHomologarAdjudicarItemLote from './components/ModalHomologarAdjudicarItemLote'
import ModalDesempateManualAutomatico from './components/ModalDesempateManualAutomatico'
import ModalAcompanhamentoEnvioEsfinge from './components/ModalAcompanhamentoEnvioEsfinge'
import AlertaAvisoValidacaoSaldo from './components/AlertaAvisoValidacaoSaldo'

export default {
    name: 'ResultadoComprador',
    mixins: [SmartTimerMixin],
    components: {
        AlertaAvisoValidacaoSaldo,
        ModalDesempateManualAutomatico,
        ModalHomologarAdjudicarItemLote,
        ModalEnviarMotivoJustificativa,
        ChatSheet,
        PainelRanking,
        ModalAcompanhamentoEnvioEsfinge
    },
    props: ['paginacao', 'paginas'],
    data() {
        return {
            compraDiretaId: null,
            websocketSubscriptionForMessage: null,
            websocketSubscriptionForUserStatus: null,
            deveMostrarModalMotivoJustificativa: false,
            elementoEmDevolucao: {},
            deveMostrarModalHomologacao: false,
            deveMostrarModalDesempateManual: false,
            itemLoteEmDesempate: { ranking: [] },
            envioEsfinge: {
                historico: []
            },
            mostrarModalAcompanhamentoEnvioEsfinge: false,
            mensagensAlertaControleSaldo: [],
            deveAbrirAlertaControleSaldo: false,
            declararVencedorOuHomologar: null,
            paginacaoInterna: {
                page: 1,
                rowsPerPage: 10
            },
            linhasPorPagina: [10, 25, 50, 100],
            totalElements: 0,
            totalPages: 0,
            isBaixandoAta: false,
        }
    },
    computed: {
        ...mapState(['comprador', 'resumoCompraDireta', 'chat', 'websocketService', 'loki', 'parametros']),
        semValorReferencia(){
            return this.ehLei14_133(this.resumoCompraDireta.amparoLegal) && !this.resumoCompraDireta.possuiValorReferencia
        },
        situacaoCompraDireta() {
            return this.resumoCompraDireta.situacao
        },
        ehCompraPropostaManualEhAtiva() {
            return this.propostaManualAtiva && this.amparoLegalEhLei14133Art75VIII
        },
        propostaManualAtiva() {
            return Boolean(this.parametros.propriedadesCompraDiretas.propostaManual)
        },
        amparoLegalEhLei14133Art75VIII() {
            const lei = this.resumoCompraDireta?.amparoLegal?.lei || ''
            return typeof lei === 'string' && lei.includes('Lei 14.133/2021, Art. 75, VIII')
        },
        quantidadeCasasDecimais() {
            if (this.comprador.resultadoCompraDireta.tipo === 'COM_DISPUTA' && this.comprador.resultadoCompraDireta.disputaPor === 'UNITARIO') {
                return this.comprador.resultadoCompraDireta.casasDecimais
            }
            return 2
        },
        resultados(){
            return this.comprador.resultadoItensELotes
        },
        numeroProtocolo(){
            return this.comprador.resultadoCompraDireta.numeroProtocolo
        },
        itensLotesAguardandoHomologacao() {
            return this.resultados.filter(item => item.estaEmHomologacao)
        },
        detalhesCompra(){
            return this.chat.conversacao.compra
        },
        destinatarioConversacao(){
            return this.chat.conversacao.destinatario
        },
        ehProcessoDeHomologacaoAutoridadeSuperior() {
            return this.$route.query.processamento && this.$route.query.processamento === 'homologacao'
        },
        existeItemLoteComSituacaoEmAndamento() {
            return this.comprador.resultadoCompraDireta.existeItemLoteComSituacaoEmAndamento
        }
    },
    async mounted() {
        try {
            this.setCompraDiretaId()
            await this.buscarResultadoItensELotes()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }

        await this.contarTotalMensagensNaoLidasCentral()
        await this.abrirChatMensagens()
        this.$root.$on('notificacaoMensagemClicked', async () => await this.abrirChatMensagens())

        const subscribeWebsocketInterval = setInterval(() => {
            if(this.websocketService){
                this.subcribeForUserFornecedorOnlineStatus()
                clearInterval(subscribeWebsocketInterval)
            }
        }, 60000)
        
        this.createSmartTimer('consultarFornecedorOnlineACada2Minutos', 'consultarFornecedorOnlineACada2Minutos', 120000, {
            autostart: true,
            immediate: true
        })
    },
    beforeDestroy() {
        this.unsubscribeForChatMessage()
        this.$store.commit(mutationTypes.SET_DEVE_ABRIR_CHAT, false)
        this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_ESTADO_INICIAL)
    },
    methods: {
        async buscarResultadoItensELotes() {
            const params = {
                compraDiretaId: this.compraDiretaId,
                page: this.paginacaoInterna.page - 1,
                rowsPerPage: this.paginacaoInterna.rowsPerPage
            }
            const response = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_RESULTADO_ITENS_E_LOTES, params)
            this.totalElements = response.totalElements
            this.totalPages = response.totalPages

        },
        predicateHomologacao(elemento) {
            if(!this.ehProcessoDeHomologacaoAutoridadeSuperior) return true
            return elemento.estaEmHomologacao
        },
        async iniciarDesempateFechado(comboPainelRanking) {
            const comboDesempate = {
                compraDiretaId: this.compraDiretaId,
                itemOuLoteId: comboPainelRanking.id,
                tipo: comboPainelRanking.tipo
            }
            this.setMensagemLoading('Iniciando desempate etapa fechada..')

            try {
                await this.$store.dispatch(actionTypes.COMPRADOR.DESEMPATAR_FORNECEDORES_ETAPA_FECHADA, comboDesempate)
                await this.buscarResultadoItensELotes()

                this.mostrarNotificacaoSucesso('Iniciado desempate etapa fechada')
            } catch (error) {
                this.mostrarNotificacaoErro('Ocorreu um erro ao iniciar o desempate. Por favor, tente novamente.')
            } finally {
                this.desabilitarLoadingGlobal()
            }
        },
        async desempatar(dadosDesempate) {
            const comboDesempate = {
                compraDiretaId: this.compraDiretaId,
                ...dadosDesempate
            }
            this.setMensagemLoading('Desempatando fornecedores por sorteio...')
            const resposta =await this.$store.dispatch(actionTypes.COMPRADOR.DESEMPATAR_FORNECEDORES, comboDesempate)

            this.desabilitarLoadingGlobal()

            if(resposta.realizadoComSucesso){
                await this.buscarResultadoItensELotes()
                this.mostrarNotificacaoSucesso('Sorteio realizado com sucesso!')
                this.fecharModalDesempateManual()
            }else{
                this.mostrarNotificacaoErro('Ocorreu um erro ao realizar o sorteio. Por favor, tente novamente.')
            }
        },
        async adjudicar(itensSelecionados) {
            if(itensSelecionados.length <= 0)
                throw new Error('Selecione ao menos um item/lote para adjudicar.')

            const itensASeremAdjudicados = itensSelecionados.map(elemento => {
                return {
                    rankingId: elemento.ranking.find(rank => rank.status === 'EM_ANALISE').rankingId,
                    tipoItemOuLote: elemento.tipo
                }
            })

            const comboAdjudicacao = {
                compraDiretaId: this.compraDiretaId,
                itens: itensASeremAdjudicados
            }
            this.setMensagemLoading('Homologando/Adjudicando fornecedor...')
            const response = await this.$store.dispatch(actionTypes.COMPRADOR.ADJUDICAR_FORNECEDOR, comboAdjudicacao)

            if(response.status === 204){
                await this.buscarResultadoItensELotes()
                this.desabilitarLoadingGlobal()
                this.mostrarNotificacaoSucesso('Fornecedor adjudicado/homologado com sucesso!')
                this.fecharModalHomologacao()
            }
            else{
                throw new Error('Aconteceu um erro inesperado ao adjudicar/homologar o fornecedor!')
            }
        },
        fecharModalHomologacao(){
            this.deveMostrarModalHomologacao = false
        },
        async declararVencedor(comboPainelRanking) {
            const dados = {
                compraDiretaId: this.compraDiretaId,
                rankingId: comboPainelRanking.rankingId,
                tipoItemOuLote: comboPainelRanking.tipoItemOuLote
            }

            const isLote = String(dados.tipoItemOuLote) === 'LOTE'
            const isSituacaoEmAndamento = String(comboPainelRanking.situacaoItemOuLote) === 'EM_ANDAMENTO'
            if (isLote && isSituacaoEmAndamento && this.ehCompraPropostaManualEhAtiva) {
                try {

                    await this.$store.dispatch(actionTypes.COMPRADOR.ENVIAR_REAJUSTE_LOTE, {
                        compraDiretaId: this.compraDiretaId,
                        loteCompraDiretaId: comboPainelRanking.itemOuLoteId,
                        fornecedorId: comboPainelRanking.pessoaId
                    })

                } catch (e) {
                    const msg = (e && e.response && e.response.data && (e.response.data.message || e.response.data.mensagem)) || e.message || 'Falha ao enviar reajuste do lote.'
                    this.mostrarNotificacaoErro(msg)
                }
            }

            this.setMensagemLoading('Declarando fornecedor vencedor...')
            await this.$store.dispatch(actionTypes.COMPRADOR.DECLARAR_FORNECEDOR_VENCEDOR, dados)
            await this.buscarResultadoItensELotes()
            this.desabilitarLoadingGlobal()
            this.mostrarNotificacaoSucesso('Fornecedor declarado vencedor com sucesso!')
        },
        async enviarParaHomologacao(comboPainelRanking) {
            const dados = {
                compraDiretaId: this.compraDiretaId,
                rankingId: comboPainelRanking.rankingId,
                tipoItemOuLote: comboPainelRanking.tipoItemOuLote
            }
            this.setMensagemLoading('Enviando para homologação...')
            await this.$store.dispatch(actionTypes.COMPRADOR.ENVIAR_PARA_HOMOLOGACAO, dados)
            await this.buscarResultadoItensELotes()
            this.desabilitarLoadingGlobal()
            this.mostrarNotificacaoSucesso('Enviado com sucesso para homologação!')
        },
        async confirmarDeclaracaoVencedor() {
            await this.executarAcao(this.dados, this.declararVencedorOuHomologar)
            this.fecharModalAlertaSaldo()
        },
        deveVerificarSaldo(){
            return (this.parametros.propriedadesCompraDiretas.controleSaldoAtivo
                && this.resumoCompraDireta.origem === 'CP_PREP')
        },
        async processarAcaoAdjudicarDeclararVencedor(dados, acao){
            if(this.deveVerificarSaldo())
                await this.verificarSaldo(dados, acao)
            else
                await this.executarAcao(dados, acao)
        },

        async verificarSaldo(dados, acao){
            const requestData = {
                compraDiretaId: this.compraDiretaId,
                ...dados
            }
            const response = await this.$store.dispatch(actionTypes.COMPRADOR.VERIFICAR_SALDO_SUBELEMENTO, requestData)

            if(!response.possuiSaldo){
                this.declararVencedorOuHomologar = acao
                this.dados = dados
                this.deveAbrirAlertaControleSaldo = true
                this.mensagensAlertaControleSaldo = [ ...response.mensagens ]
            } else if(response.possuiSaldo) {
                await this.executarAcao(dados, acao)
            }

        },

        async executarAcao(dados, acao) {
            if(acao === 'DECLARAR_VENCEDOR'){
                await this.declararVencedor(dados)
            } else if(acao === 'ENVIAR_PARA_HOMOLOGACAO'){
                await this.enviarParaHomologacao(dados)
            }
        },

        fecharModalAlertaSaldo(){
            this.deveAbrirAlertaControleSaldo = false
        },
        async reverterSituacao(comboPainelRanking) {
            const isLote = comboPainelRanking.tipoItemOuLote.toUpperCase() === 'LOTE'
            const comboReverter = {
                compraDiretaId: this.compraDiretaId,
                itemOuLoteId: comboPainelRanking.itemOuLoteId,
                isLote: isLote
            }
            this.setMensagemLoading('Revertendo situação...')
            await this.$store.dispatch(actionTypes.COMPRADOR.REVERTER_SITUACAO_ITEM_LOTE, comboReverter)
            await this.buscarResultadoItensELotes()
            this.desabilitarLoadingGlobal()
            this.mostrarNotificacaoSucesso('Situação alterada com sucesso!')
        },
        async desclassificar(comboPainelRanking) {
            const comboDesclassificacao = {
                compraDiretaId: this.compraDiretaId,
                rankingId: comboPainelRanking.rankingId,
                tipoItemOuLote: comboPainelRanking.tipoItemOuLote,
                motivo: comboPainelRanking.motivo
            }
            this.setMensagemLoading('Desclassificando fornecedor...')
            await this.$store.dispatch(actionTypes.COMPRADOR.DESCLASSIFICAR_FORNECEDOR, comboDesclassificacao)
            await this.buscarResultadoItensELotes()
            this.desabilitarLoadingGlobal()
            this.mostrarNotificacaoSucesso('Fornecedor desclassificado com sucesso!')
        },
        async inabilitar(comboPainelRanking) {
            const comboInabilitacao = {
                compraDiretaId: this.compraDiretaId,
                rankingId: comboPainelRanking.rankingId,
                tipoItemOuLote: comboPainelRanking.tipoItemOuLote,
                motivo: comboPainelRanking.motivo,
                inabilitarTodos: comboPainelRanking.inabilitarTodos,
                fornecedorId: comboPainelRanking.fornecedorId
            }

            this.setMensagemLoading('Inabilitando fornecedor...')
            await this.$store.dispatch(actionTypes.COMPRADOR.INABILITAR_FORNECEDOR, comboInabilitacao)
            await this.buscarResultadoItensELotes()
            this.desabilitarLoadingGlobal()
            this.mostrarNotificacaoSucesso('Fornecedor inabilitado com sucesso!')
        },
        async habilitar(comboPainelRanking) {
            const comboHabilitacao = {
                compraDiretaId: this.compraDiretaId,
                rankingId: comboPainelRanking.rankingId,
                tipoItemOuLote: comboPainelRanking.tipoItemOuLote,
                motivo: comboPainelRanking.motivo,
                habilitarTodos: comboPainelRanking.habilitarTodos,
                fornecedorId: comboPainelRanking.fornecedorId
            }

            this.setMensagemLoading('Habilitando fornecedor...')
            await this.$store.dispatch(actionTypes.COMPRADOR.HABILITAR_FORNECEDOR, comboHabilitacao)
            await this.buscarResultadoItensELotes()
            this.desabilitarLoadingGlobal()
            this.mostrarNotificacaoSucesso('Fornecedor habilitado com sucesso!')
        },
        async reclassificar(comboPainelRanking) {
            const comboReclassificacao = {
                compraDiretaId: this.compraDiretaId,
                rankingId: comboPainelRanking.rankingId,
                tipoItemOuLote: comboPainelRanking.tipoItemOuLote,
                motivo: comboPainelRanking.motivo
            }
            this.setMensagemLoading('Reclassificando fornecedor...')
            await this.$store.dispatch(actionTypes.COMPRADOR.RECLASSIFICAR_FORNECEDOR, comboReclassificacao)
            await this.buscarResultadoItensELotes()
            this.desabilitarLoadingGlobal()
            this.mostrarNotificacaoSucesso('Fornecedor reclassificado com sucesso!')
        },
        async negociar(comboPainelRanking) {
            const comboNegociacao = {
                compraDiretaId: this.compraDiretaId,
                tipoItemOuLote: comboPainelRanking.tipoItemOuLote,
                itemOuLoteId: comboPainelRanking.itemOuLoteId,
                rankingId: comboPainelRanking.rankingId,
                mensagem: comboPainelRanking.mensagem
            }
            this.setMensagemLoading('Enviando negociação para o fornecedor...')
            await this.$store.dispatch(actionTypes.COMPRADOR.NEGOCIAR_ITEM_OU_LOTE, comboNegociacao)
            this.desabilitarLoadingGlobal()
            this.mostrarNotificacaoSucesso('Negociação enviada com sucesso!')
        },
        async baixarAtaCompraDireta() {
            if (this.isBaixandoAta) {
                this.mostrarNotificacaoErro('Já existe um download em andamento. Aguarde a finalização.')
                return
            }
            this.isBaixandoAta = true
            try {
                await this.$store.dispatch(actionTypes.BAIXAR_RELATORIO_DA_ATA_DA_COMPRA_DIRETA, this.compraDiretaId)
                this.mostrarNotificacaoSucesso('Relatório da Ata baixado com sucesso!')
            } finally {
                this.isBaixandoAta = false
            }
        },
        async baixarHistoricoLances() {
            await this.$store.dispatch(actionTypes.COMPRADOR.BAIXAR_HISTORICO_DE_LANCES, this.compraDiretaId)
        },
        async baixarResultado() {
            await this.$store.dispatch(actionTypes.COMPRADOR.BAIXAR_RESULTADO_ITENS_E_LOTES, this.compraDiretaId)
        },
        async cancelarAdjudicacao(comboPainelRanking){
            const combo = {
                compraDiretaId: this.compraDiretaId,
                processo: this.resumoCompraDireta.processo,
                tipoItemOuLote: comboPainelRanking.tipoItemOuLote,
                rankingId: comboPainelRanking.rankingId,
                motivo: comboPainelRanking.motivo,
                pessoaId: comboPainelRanking.pessoaId,
                itemOuLoteId: comboPainelRanking.itemOuLoteId
            }
            await this.$store.dispatch(actionTypes.COMPRADOR.CANCELAR_ADJUDICACAO, combo)
            this.mostrarNotificacaoSucesso('Adjudicação cancelada com sucesso!')
        },
        async cancelarDeclaracaoVencedor(comboPainelRanking){
            const combo = {
                compraDiretaId: this.compraDiretaId,
                processo: this.resumoCompraDireta.processo,
                tipoItemOuLote: comboPainelRanking.tipoItemOuLote,
                rankingId: comboPainelRanking.rankingId,
                motivo: comboPainelRanking.motivo,
                pessoaId: comboPainelRanking.pessoaId,
                itemOuLoteId: comboPainelRanking.itemOuLoteId
            }
            await this.$store.dispatch(actionTypes.COMPRADOR.CANCELAR_DECLARACAO_VENCEDOR, combo)
            this.mostrarNotificacaoSucesso('Declaração vencedor cancelada com sucesso!')
        },
        async cancelarNegociacao(comboPainelRanking) {
            const combo = {
                compraDiretaId: this.compraDiretaId,
                tipoItemOuLote: comboPainelRanking.tipoItemOuLote,
                itemOuLoteId: comboPainelRanking.itemOuLoteId,
                negociacaoId: comboPainelRanking.negociacaoId,
                motivo: comboPainelRanking.motivo
            }
            await this.$store.dispatch(actionTypes.COMPRADOR.CANCELAR_NEGOCIACAO, combo)
            this.mostrarNotificacaoSucesso('Negociação cancelada com sucesso!')

        },
        async analisarDocumentacao(comboPainelRanking) {
            const params = {
                id: this.compraDiretaId,
                fornecedorId: comboPainelRanking.pessoaId,
                itemLoteId: comboPainelRanking.itemLoteId,
                itemLoteTipo: comboPainelRanking.itemLoteTipo
            }
            try {
                await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_ANALISE_DOCUMENTOS_DO_FORNECEDOR, {
                    compraDiretaId: params.id,
                    fornecedorId: params.fornecedorId,
                    itemLoteId: params.itemLoteId,
                    itemLoteTipo: params.itemLoteTipo
                })
            } catch (e) {
                const resp = e && e.response && e.response.data
                const msg = (resp && (resp.message || resp.mensagem)) || e.message || 'Não foi possível carregar a análise de documentos.'
                this.mostrarNotificacaoErro(msg)
            }
            this.$router.push({ name: 'AnaliseDocumentacao', params })
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        },
        tratarEventoVoltar() {
            this.$router.push({name: 'AcompanhamentoVisualizacao', params: this.compraDiretaId})
        },
        async encerrarCompra() {
            this.habilitarLoadingGlobal()
            this.setMensagemLoading('Encerrando Compra Direta...')

            try {
                await this.$store.dispatch(actionTypes.COMPRADOR.ENCERRAR_COMPRA_DIRETA, this.compraDiretaId)
                this.mostrarNotificacaoSucesso('Compra direta encerrada com sucesso.')
                setTimeout(() => this.exportarResultadoAposEncerramento(), 1000)
            } catch (e) {
                this.desabilitarLoadingGlobal()
                this.mostrarNotificacaoErro(e.message)
            }
            this.desabilitarLoadingGlobal()
        },
        async executarEventoBaixarTodosDocumentos(data) {
            await this.$store.dispatch(actionTypes.COMPRADOR.BAIXAR_TODOS_DOCUMENTOS_APRESENTADOS, data)
        },
        async eventoVisualizarProposta(dados){
            await this.$store.dispatch(actionTypes.COMPRADOR.BAIXAR_RELATORIO_PROPOSTAS_ITEM_LOTE, {compraDiretaId: this.compraDiretaId, ...dados})
        },
        async enviarSolicitacaoReadequacaoItemLote(dados){
            await this.$store.dispatch(actionTypes.COMPRADOR.ENVIAR_SOLICITACAO_REAJUSTE_ITEM_LOTE, {compraDiretaId: this.compraDiretaId, ...dados})
            this.mostrarNotificacaoSucesso('Operação realizada com sucesso!')
        },
        async exportarResultadoAposEncerramento() {
            if(this.resumoCompraDireta.origem === 'SGC')
                await this.$store.dispatch(actionTypes.EXPORTAR_COMPRA_DIRETA, this.compraDiretaId)
            else
                await this.$store.dispatch(actionTypes.EXPORTAR_RESULTADOS_COMPRAS_PREPARACAO, this.compraDiretaId)

            this.mostrarNotificacaoSucesso('Resultado Compra direta exportada com sucesso.')
        },
        async processarEventoCancelarEnvioHomologacao(comboPainelRanking) {
            const dados = {
                compraDiretaId: this.compraDiretaId,
                rankingId: comboPainelRanking.rankingId,
                tipo: comboPainelRanking.tipoItemOuLote
            }
            await this.$store.dispatch(actionTypes.COMPRADOR.CANCELAR_ENVIO_PARA_HOMOLOGACAO, dados)
            this.mostrarNotificacaoSucessoDefault()
        },
        processarEventoAbrirModalMotivoJustificativa({ descricao, tipo }, {rankingId}) {
            this.elementoEmDevolucao = { descricao, tipo, rankingId }
            this.deveMostrarModalMotivoJustificativa = true
        },
        fecharModalMotivoDevolucao() {
            this.elementoEmDevolucao = {}
            this.deveMostrarModalMotivoJustificativa = false
        },
        async processarConfirmacaoDevolucaoItemLote(motivo) {
            const dados = {
                rankingId: this.elementoEmDevolucao.rankingId,
                motivoDevolucao: motivo,
                tipo: this.elementoEmDevolucao.tipo
            }

            await this.$store.dispatch(actionTypes.AUTORIDADE_SUPERIOR.DEVOLVER_ITEM_LOTE, {compraDiretaId: this.compraDiretaId, ...dados})
            this.mostrarNotificacaoSucessoDefault()
            this.fecharModalMotivoDevolucao()
        },
        async processarEventoBaixarTermoHomologacao(){
            try {
                await this.$store.dispatch(actionTypes.COMPRADOR.BAIXAR_TERMO_HOMOLOGACAO, this.compraDiretaId)
            } catch (e) {
                this.mostrarNotificacaoErro('Não foi possível baixar o termo de homologação.')
            }
        },
        iniciarDesempateManualAutomatico(itemLoteDesempate) {
            if(!itemLoteDesempate.empate)
                throw new Error('Não existe fornecedores empatados para esse item/lote.')

            this.itemLoteEmDesempate = itemLoteDesempate

            this.deveMostrarModalDesempateManual = true
        },
        async processarConfirmacaoDesempateManual({classificacoes, justificativa}) {
            const requestData = {
                compraDiretaId: this.compraDiretaId,
                justificativa: justificativa,
                classificacoes: classificacoes,
                itemOuLoteId: this.itemLoteEmDesempate.id,
                tipo: this.itemLoteEmDesempate.tipo
            }

            const resposta = await this.$store.dispatch(actionTypes.COMPRADOR.DESEMPATAR_FORNECEDOR_MANUALMENTE, requestData)

            if(resposta.realizadaComSucesso) {
                this.mostrarNotificacaoSucessoDefault()
                this.fecharModalDesempateManual()
                await this.buscarResultadoItensELotes()
            }
            else
                throw new Error('Não foi possível realizar essa operação. Por favor, tente novamente.')
        },
        fecharModalDesempateManual() {
            this.deveMostrarModalDesempateManual = false
            this.itemLoteEmDesempate = {ranking: [] }
        },
        tempoDesempateEncerrado(){
            const timeOut = setTimeout(async () => {
                await this.buscarResultadoItensELotes()
                clearTimeout(timeOut)
            }, 2500)
        },

        /**
         *  TODO Parte do chat
         */
        async contarTotalMensagensNaoLidasCentral() {
            await this.$store.dispatch(actionTypes.CONTAR_MENSAGENS_PARA_CENTRAL_CHAT, {
                compraDiretaId: this.compraDiretaId,
                ehComprador: true
            })
        },
        async processarEventoAbrirchatMensagens(itemOuLote, resultadoItemLote) {
            if(!this.websocketService)
                throw new Error('A conexão websocket foi encerrada, atualize a página.')

            this.unsubscribeForChatMessage()

            const destinatario = {
                id: resultadoItemLote.pessoaId,
                nome: resultadoItemLote.razaoSocial,
                iniciais: this.getInicias(resultadoItemLote.razaoSocial)
            }
            const detalhes = {
                compraDiretaId: this.compraDiretaId,
                processo: this.resumoCompraDireta.processo,
                itemOuLoteDescricao: itemOuLote.descricao,
                itemCompraDiretaId: ('ITEM' === itemOuLote.tipo) ? itemOuLote.id : null,
                loteCompraDiretaId: ('LOTE' === itemOuLote.tipo) ? itemOuLote.id : null,
                tipo: itemOuLote.tipo,
            }
            this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_MENSAGENS, [])
            this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_DETALHES_COMPRA, detalhes)
            this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_DESTINATARIO, destinatario)
            await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_DESTINATARIO_CHAT_E_MENSAGENS)
            this.$store.commit(mutationTypes.SET_ITEM_OU_LOTE_ATUAL_DO_CHAT, itemOuLote)
            this.$store.commit(mutationTypes.SET_CURRENT_TAB_CHAT, 'tab-mensagens')
            this.$store.commit(mutationTypes.SET_DEVE_ABRIR_CHAT, true)
            this.subscribeForChatMessage()
        },
        async processarEventoAbrirChatNoTabItensLotes() {
            const {data} = await this.$store.dispatch(actionTypes.CONTAR_MENSAGENS_NAO_LIDAS_ITENS_LOTES, {
                compraDiretaId: this.compraDiretaId,
                ehComprador: true
            })

            data.itens.forEach(item => {
                const lista = (this.comprador && Array.isArray(this.comprador.resultadoItensELotes))
                    ? this.comprador.resultadoItensELotes
                    : []
                const alvo = lista.find(r => r.tipo === item.tipo && Number(r.id) === Number(item.id))
                if (alvo) {
                    if (typeof alvo.totalMensagensNaoLidas !== 'number') {
                        this.$set(alvo, 'totalMensagensNaoLidas', item.totalNaoLidas)
                    } else {
                        alvo.totalMensagensNaoLidas = item.totalNaoLidas
                    }
                }
            })

            this.$store.commit(mutationTypes.SET_DEVE_ABRIR_CHAT, true)
            this.$store.commit(mutationTypes.SET_CURRENT_TAB_CHAT, 'tab-itens-lotes')
        },
        async processarEventoFornecedorClicked(itemOuLote, pessoa) {
            if(!this.websocketService)
                throw new Error('A conexão websocket foi encerrada, atualize a página.')

            this.unsubscribeForChatMessage()

            const destinatario = {
                id: pessoa.pessoaId,
                nome: pessoa.razaoSocial,
                iniciais: this.getInicias(pessoa.razaoSocial)
            }
            const detalhes = {
                compraDiretaId: this.resumoCompraDireta.id,
                processo: this.resumoCompraDireta.processo,
                itemOuLoteDescricao: itemOuLote.descricao,
                itemCompraDiretaId: pessoa.itemCompraDiretaId,
                loteCompraDiretaId: pessoa.loteCompraDiretaId,
                tipo: itemOuLote.tipo,
            }

            this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_MENSAGENS, [])
            this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_DETALHES_COMPRA, detalhes)
            this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_DESTINATARIO, destinatario)
            await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_DESTINATARIO_CHAT_E_MENSAGENS)
            this.$store.commit(mutationTypes.SET_ITEM_OU_LOTE_ATUAL_DO_CHAT, itemOuLote)
            this.$store.commit(mutationTypes.SET_CURRENT_TAB_CHAT, 'tab-mensagens')
            this.$store.commit(mutationTypes.SET_DEVE_ABRIR_CHAT, true)
            this.subscribeForChatMessage()
            await this.marcarMensagensComoLidas(itemOuLote)
        },
        processarEventoFecharChat(){
            this.$store.commit(mutationTypes.SET_DEVE_ABRIR_CHAT, false)
            this.unsubscribeForChatMessage()
        },
        processarEventoTabCliked(tab){
            if(tab === 'tab-itens-lotes') {
                this.unsubscribeForChatMessage()
                this.processarEventoAbrirChatNoTabItensLotes()
            }else if(!this.websocketSubscriptionForMessage)
                this.subscribeForChatMessage()
            this.$store.commit(mutationTypes.SET_CURRENT_TAB_CHAT, tab)
        },
        subscribeForChatMessage(){
            const itemOuLoteId = this.getItemOuLoteId()
            const topicChat = `/topic/compraDiretaId=${this.compraDiretaId}&itemOuLote=${itemOuLoteId}`

            this.websocketSubscriptionForMessage = this.websocketService.subscribe(topicChat, (message) => {
                const body = JSON.parse(message.body)
                body.ehMensagemMinha = (body.remetente.id === this.loki.user.domainId && body.remetente.tipo === this.loki.user.domainType)
                this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_MENSAGENS, [body])
                this.contarTotalMensagensNaoLidasCentral()
            })

            this.atualizarStatusChatDestinatario()
        },
        unsubscribeForChatMessage(){
            if(this.websocketSubscriptionForMessage) {
                this.websocketService.unsubscribe(this.websocketSubscriptionForMessage.id)
                this.websocketSubscriptionForMessage = null
            }
        },
        getInicias(razaoSocial){
            const parts = razaoSocial.split(' ')
            if(parts.length > 1)
                return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase()
            return parts[0].substring(0, 2).toUpperCase()
        },
        getItemOuLoteId(){
            if(this.detalhesCompra.tipo === 'ITEM')
                return this.detalhesCompra.itemCompraDiretaId
            return this.detalhesCompra.loteCompraDiretaId
        },
        atualizarStatusChatDestinatario() {
            const usuario = this.chat.usuariosOnline.find(usuario => usuario.dominioId === this.destinatarioConversacao.id)
            const online = !!(usuario && usuario.online)
            const id = this.destinatarioConversacao && this.destinatarioConversacao.id
            if (id)
                this.$store.commit(mutationTypes.SET_CHAT_DESTINATARIO_ONLINE, { id, online })
        },
        async marcarMensagensComoLidas(itemOuLote){
            const { data } = await this.$store.dispatch(actionTypes.MARCAR_MENSAGENS_LIDAS_ITENS_LOTES, {
                tipo: itemOuLote.tipo,
                ehComprador: true
            })

            const alvo = this.resultados.find(r => Number(r.id) === Number(data.id) && r.tipo === data.tipo)
            if (alvo) {
                if (typeof alvo.totalMensagensNaoLidas !== 'number') {
                    this.$set(alvo, 'totalMensagensNaoLidas', 0)
                } else {
                    alvo.totalMensagensNaoLidas = 0
                }
            }
        },
        async abrirChatMensagens(){
            if(this.chat.deveAbrirChat) {
                this.unsubscribeForChatMessage()
                this.subscribeForChatMessage()

                const {tipo, itemCompraDiretaId, loteCompraDiretaId} = this.detalhesCompra
                const itemOuLoteAtual = this.resultados.find(r => this.predicateItemLoteAtualDoChat(r, tipo, (itemCompraDiretaId || loteCompraDiretaId)))

                if(itemOuLoteAtual)
                    this.$store.commit(mutationTypes.SET_ITEM_OU_LOTE_ATUAL_DO_CHAT, itemOuLoteAtual)
            }
        },
        predicateItemLoteAtualDoChat(resultado, tipo, itemOuLoteId){
            return resultado.tipo === tipo && resultado.id === itemOuLoteId
        },
        /**
         * TODO subscribe para user fornecedor status
         */

        subcribeForUserFornecedorOnlineStatus(){
            this.websocketService.subscribe('/topic/CONSULTAR:FORNECEDOR:ONLINE', (message) => {
                this.$store.commit(mutationTypes.SET_USUARIOS_ONLINE_COMPRA_DIRETA, JSON.parse(message.body))
            })
            this.consultarFornecedorOnline()

            this.websocketService.subscribe('/topic/ESTRUTURA_ORGANIZACIONAL:ONLINE', () => {
                const dados = {
                    tipo: this.loki.user.domainType,
                    usuarioId: this.loki.user.id,
                    dominioId: this.loki.user.domainId,
                    online: true
                }
                this.websocketService.send('/topic/CONSULTAR:ESTRUTURA_ORGANIZACIONAL:ONLINE', JSON.stringify(dados))
            })
        },

        consultarFornecedorOnline(){
            if(this.websocketService)
                this.websocketService.send('/topic/FORNECEDOR:ONLINE', {})
        },

        /**
         * TODO Enviar mensagem
         */
        processarEventoEnviarMensagem(mensagem){
            const itemOuLoteId = this.getItemOuLoteId()
            const dados = {
                compraDiretaId: this.compraDiretaId,
                itemOuLoteId: itemOuLoteId,
                tipo: this.detalhesCompra.tipo,
                mensagem: mensagem,
                fornecedorId: this.destinatarioConversacao.id,
                uoId: this.loki.user.domainId,
                usuarioId: this.loki.user.id
            }
            const headers = {
                origemComprador: true
            }

            this.websocketService.send(`/chat/chat-privado/${this.compraDiretaId}/${itemOuLoteId}`, JSON.stringify(dados), headers)
            this.marcarMensagensComoLidas({tipo: this.detalhesCompra.tipo})
            this.contarTotalMensagensNaoLidasCentral()
        },

        consultarFornecedorOnlineACada2Minutos(){
            this.consultarFornecedorOnline()
        },

        async processarPrimerioEnvioEsfinge() {
            await this.enviarDispensaEsfinge()
            await this.buscarResultadoItensELotes()
        },

        async processarEventoRemoverProposta(dados) {
            try {
                await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_TERMOS, {
                    compraDiretaId: this.compraDiretaId,
                    fornecedorId: dados.fornecedorId
                })
                const propostaId = this.$store.state.termos?.id

                if (!propostaId) {
                    this.mostrarNotificacaoErro('Não foi possível identificar a proposta do fornecedor para remover.')
                    return
                }

                await this.$store.dispatch(actionTypes.COMPRADOR.REMOVER_PROPOSTA, {
                    compraDiretaId: this.compraDiretaId,
                    propostaId,
                    fornecedorId: dados.fornecedorId
                })

                this.mostrarNotificacaoSucesso('Proposta removida com sucesso.')
                await this.$store.dispatch(actionTypes.COMPRADOR.RANKEAR_PROPOSTAS, { compraDiretaId: this.compraDiretaId })
                await this.$store.dispatch(actionTypes.COMPRADOR.INSERIR_REAJUSTE_PROPOSTAS, { compraDiretaId: this.compraDiretaId })

                await this.buscarResultadoItensELotes()
            } catch (e) {
                const msg = (e && e.response && e.response.data && (e.response.data.message || e.response.data.mensagem)) || e.message || 'Erro ao remover proposta.'
                this.mostrarNotificacaoErro(msg)
            }
        },

        async processarEnvioModalAcompanhamentoEsfinge() {
            await this.enviarDispensaEsfinge()
            setTimeout(async () => await this.buscarDispensaEsfinge(), 1500)
        },

        async enviarDispensaEsfinge() {
            const data = await this.$store.dispatch(actionTypes.ESFINGE.ENVIAR_DISPENSA, this.compraDiretaId)

            if (data.enviadoComSucesso)
                this.mostrarNotificacaoSucesso('Enviado a Dispensa para o E-SFINGE com sucesso.')
            else
                this.mostrarNotificacaoErro('Erro ao Enviar a Dispensa para o E-SFINGE.')
        },

        async alterarDispensaEsfinge() {
            const data = await this.$store.dispatch(actionTypes.ESFINGE.ALTERAR_DISPENSA, this.compraDiretaId)

            if (data.alteradoComSucesso)
                this.mostrarNotificacaoSucesso('Alterada a Dispensa para o E-SFINGE com sucesso.')
            else
                this.mostrarNotificacaoErro('Erro ao Alterar a Dispensa para o E-SFINGE.')

            await this.buscarDispensaEsfinge()
        },

        async cancelarDispensaEsfinge() {
            const data = await this.$store.dispatch(actionTypes.ESFINGE.CANCELAR_DISPENSA, this.compraDiretaId)

            if (data.canceladoComSucesso)
                this.mostrarNotificacaoSucesso('Cancelada a Dispensa para o E-SFINGE com sucesso.')
            else
                this.mostrarNotificacaoErro('Erro ao Cancelar a Dispensa para o E-SFINGE.')

            await this.buscarDispensaEsfinge()
        },

        async buscarDispensaEsfinge() {
            if (this.numeroProtocolo) {
                const data = await this.$store.dispatch(actionTypes.ESFINGE.BUSCAR_DISPENSA, this.compraDiretaId)
                this.envioEsfinge = data
            }
        },

        async abrirModalAcompanhamentoEnvioEsfinge() {
            await this.buscarDispensaEsfinge()
            this.mostrarModalAcompanhamentoEnvioEsfinge = true
        },

        fecharModalAcompanhamentoEnvioEsfinge(){
            this.mostrarModalAcompanhamentoEnvioEsfinge = false
        },
    },
    watch: {
        'paginacaoInterna.page'() {
            this.buscarResultadoItensELotes()
        },
        'paginacaoInterna.rowsPerPage'() {
            this.paginacaoInterna.page = 1
            this.buscarResultadoItensELotes()
        },
        'chat.usuariosOnline'(val){
            if(val) this.atualizarStatusChatDestinatario()
        },
    }
}
</script>

<style scoped lang="stylus">
    .az-actions-form
        padding 0
</style>
